import { m } from '@aimfora/i18n'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { BetaPage } from '~/components/admin/beta-page'
import { PageHeader } from '~/components/app-shell'

export const Route = createFileRoute('/_authed/_admin/admin/beta')({
  validateSearch: z.object({
    status: z.enum(['new', 'approved', 'declined', 'all']).catch('new').default('new'),
  }),
  head: () => ({ meta: [{ title: `${m.admin_beta_title()} – ${m.app_name()}` }] }),
  component: BetaRoute,
})

function BetaRoute() {
  const { status } = Route.useSearch()
  return (
    <>
      <PageHeader title={m.admin_beta_title()} description={m.admin_beta_description()} />
      <BetaPage status={status} />
    </>
  )
}
